import { Component, Watch } from "vue-property-decorator";
import DoctorService from "@/services/doctor.service";
import { DoctorDTO } from "@/models/DoctorDTO";
import { ThingDTO } from "@/models/ThingDTO";
import AutoComplete from "@/components/inputs/base/AutoComplete/AutoComplete.vue";
import { WatchOptions } from "vue";

@Component
export default class DoctorAutoComplete extends AutoComplete<DoctorDTO> {
  public doctors: DoctorDTO[] = [];
  public errorMessage: string = "";
  public error: boolean = false;

  public convertValue(): DoctorDTO {
    return this.doctors.find(x => x.doctorId === this.search.id) as DoctorDTO;
  }

  public convertValueToThingDto(): ThingDTO {
    const doctor =
      this.value !== null && this.value !== undefined
        ? (this.value as DoctorDTO)
        : null;
    let thingDTO = {} as ThingDTO;

    if (doctor !== null) {
      thingDTO = this.items.find(x => x.id === doctor.doctorId) as ThingDTO;
    }

    return thingDTO;
  }

  public handleClickOutside(evt: any): void {
    if (!this.$el.contains(evt.target)) {
      this.isOpen = false;
      this.arrowCounter = -1;
      if (this.search && this.search.id === -99) {
        this.$emit("input", undefined);
        this.search.name = "";
      }
    }
  }

  protected formatSearchLabel(value: DoctorDTO) {
    if (value.doctorAddress && value.doctorLocality) {
      return `${value.doctorName} - ${value.doctorAddress} - ${value.doctorLocality}`;
    } else if (value.doctorAddress) {
      return `${value.doctorName} - ${value.doctorAddress}`;
    } else {
      return value.doctorName;
    }
  }

  protected onChange(value: string): void {
    super.onChange(value);
  }

  protected filterResults(): void {
    super.filterResults();
  }

  protected isSelected(i: number): boolean {
    return super.isSelected(i);
  }

  protected getId(index: number): string {
    return super.getId(index);
  }

  protected mounted() {
    this.loadDoctors();

    if (this.value) {
      this.search = {
        id: this.value.doctorId,
        name: this.formatSearchLabel(this.value)
      } as ThingDTO;
    }
  }

  protected loadDoctors(): void {
    DoctorService.fetchDoctors().then((res: DoctorDTO[]) => {
      this.doctors = res.map(x => x as DoctorDTO);
      this.items = this.doctors.map((x: DoctorDTO) => {
        return { name: this.formatSearchLabel(x), id: x.doctorId } as ThingDTO;
      });

      this.search = this.convertValueToThingDto();

      super.mounted();
    });
  }

  @Watch("value", { deep: true } as WatchOptions)
  protected onValueChanged(value: DoctorDTO, oldValue: DoctorDTO) {
    if (oldValue !== value && value !== undefined && value !== null) {
      this.search = {
        id: value.doctorId,
        name: this.formatSearchLabel(value)
      } as ThingDTO;
    }

    if (value === null || value === undefined) {
      this.search = {} as ThingDTO;
    }
  }
}
